// Generated by ReScript, PLEASE EDIT WITH CARE


function encodeSummary(data) {
  return {
          name: data.name,
          is_portergold_active: data.is_portergold_active,
          mobile: data.mobile,
          address: data.address,
          city: data.city,
          uuid: data.uuid
        };
}

function field(value, data) {
  return {
          attribute_name: data.attribute_name,
          attribute_value: value
        };
}

function execute(data, formData) {
  var match = data.formData;
  return {
          summary: encodeSummary(data.summary),
          first_name: {
            attribute_name: match.first_name.attribute_name,
            attribute_value: formData.first_name
          },
          last_name: {
            attribute_name: match.last_name.attribute_name,
            attribute_value: formData.last_name
          },
          caller_type: {
            attribute_name: match.caller_type.attribute_name,
            attribute_value: formData.caller_type
          },
          mobile: {
            attribute_name: match.mobile.attribute_name,
            attribute_value: formData.mobile
          },
          secondary_mobile: {
            attribute_name: match.secondary_mobile.attribute_name,
            attribute_value: formData.secondary_mobile
          },
          port_gold_status: {
            attribute_name: match.port_gold_status.attribute_name,
            attribute_value: formData.port_gold_status
          },
          geo_region: {
            attribute_name: match.geo_region.attribute_name,
            attribute_value: formData.geo_region
          },
          email: {
            attribute_name: match.email.attribute_name,
            attribute_value: formData.email
          },
          unconfirmed_email: {
            attribute_name: match.unconfirmed_email.attribute_name,
            attribute_value: formData.unconfirmed_email
          },
          customer_type: {
            attribute_name: match.customer_type.attribute_name,
            attribute_value: formData.customer_type
          },
          temporarily_deactivated: {
            attribute_name: match.temporarily_deactivated.attribute_name,
            attribute_value: formData.temporarily_deactivated
          },
          blacklist_reason: {
            attribute_name: match.blacklist_reason.attribute_name,
            attribute_value: formData.blacklist_reason
          },
          registration_status: {
            attribute_name: match.registration_status.attribute_name,
            attribute_value: formData.registration_status
          },
          partload_customer: {
            attribute_name: match.partload_customer.attribute_name,
            attribute_value: formData.partload_customer
          },
          subscribed_for_promo_sms: {
            attribute_name: match.subscribed_for_promo_sms.attribute_name,
            attribute_value: formData.subscribed_for_promo_sms
          }
        };
}

export {
  encodeSummary ,
  field ,
  execute ,
  
}
/* No side effect */
